import { defineComponent as _defineComponent } from 'vue'
import { VCol, VRow } from 'ah-common-lib/src/common/components';
import { WarningExclamationIcon } from 'ah-common-lib/src/icons/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoAvailableMarkToMarket',
  props: {
  inheritedHeight: {
    type: Number,
    required: false,
  },
},
  setup(__props) {



return { __sfc: true,VCol, VRow, WarningExclamationIcon }
}

})